import React from 'react';
import { useSelector } from 'react-redux'

import leadTimeIco from 'images/pu/taxons/clock-fast-blue.svg';
import priceIco from 'images/pu/taxons/money-blue.png';
import SelectIco from 'images/pu/shared/arrow_triangle.svg';

import prototypeSmtStencilImg from 'images/pu/product_tabs/stencils/prototype_smt_stencils.png';
import framedSmtStencilImg from 'images/pu/product_tabs/stencils/framed_smt_stencils.png';
import framelessSmtStencilImg from 'images/pu/product_tabs/stencils/smt_stencils_frameless.png';

const getStencilImage = (stencilSlug) => {
  switch (stencilSlug) {
    case "prototype-smt-stencils":
      return prototypeSmtStencilImg;
    case "framed-smt-stencils":
      return framedSmtStencilImg;
    case "frameless-smt-stencils":
      return framelessSmtStencilImg;
    default:
      return '';
  }
}

const GeneralInformation = () => (
  <>
    <div className="stencil-description">
      <p className="m-0 general-description">
        <span className="price">
          <img src={priceIco} alt="Price" />
          Get 30% discount automatically on your Laser Cut SMT stencil with your PCBs
        </span>
        <span className="lead-time">
          <img src={leadTimeIco} alt="Lead Time" />
          SMT stencils ship in 24 hours.
        </span>
        <br/>
        We use state-of-the-art laser technology which manufactures stencils <br/>
        with smooth aperture walls and provides optimum solder paste volume control.
      </p>
    </div>
    <div className='d-flex align-items-center mb-3 select-paragraph'>
      <img src={SelectIco} alt="Select Stencil Product" className='stencil-select-icon'/>
      <h6 className="select-title mb-0">&nbsp;Please select a stencil type and stencil side(s)</h6>
    </div>
  </>
)

const ProductSelected = ({ product }) => {
  // const regExp = /<ul>([\s\S]*?)<\/ul>/g
  const regExp = /<li([\s\S]*?)<\/li>/g
  const searched = product.description.match(regExp);
  const chunkSize = 2;
  const bullets = [];

  for (let i = 0; i < searched.length; i += chunkSize) {
    const chunk = searched.slice(i, i + chunkSize);
    bullets.push(chunk);
  }
  const items = bullets.map((item) => `<ul>${item.join('')}</ul>`);
  // const bullets = searched && searched.length > 0 ? searched[0] : null;
  return (
    <div className="stencil-description">
      <div className='row'>
        <div className='col-lg-auto'>
          <h5 className="title">{product.name}</h5>
          <span className="lead-time">
            <img src={leadTimeIco} alt="Lead Time" />
            Lead Time: {product.lead_time}
          </span>
          <span className="price">
            <img src={priceIco} alt="Price" />
            Get 30% off on Laser Cut SMT Stencils with your PCBs
          </span>
          <div className="description">
            <div className="row">
              <div className="col-lg-auto">
                <ul>
                  {searched.map((item, idx) => <li key={idx} dangerouslySetInnerHTML={{ __html: item }} />)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-auto'>
          <img src={getStencilImage(product.slug)} alt={product.name} />
        </div>
      </div>
    </div>
  )
}

const ProductDescription = () => {
  let content;
  const {
    stencilsType,
  } = useSelector((state) => state.smtStencil);
  if (!stencilsType) {
    content = <GeneralInformation />
  } else {
    const product = Spree.stencils_info.find((stencil) => stencil.slug === stencilsType);
    content = <ProductSelected product={product} />
  }
  return (
    <>
      {content}
    </>
  )
};

ProductDescription.defaultProps = {};

export default ProductDescription;
